/**
 * CDS Before/After Slider
 * Compatible: Shopify Horizon Theme
 * Version: 2.1 - Improved reactivity
 */

(function() {
  'use strict';

  function initAllSliders() {
    const sliderContainers = document.querySelectorAll('.cds-before-after__slider-container');
    sliderContainers.forEach(container => initSlider(container));
  }

  function initSlider(container) {
    if (!container || container.dataset.initialized) return;
    
    const slider = container.querySelector('.cds-before-after__slider');
    const beforeImage = container.querySelector('.cds-before-after__before');
    const startPosition = parseInt(container.dataset.sliderStart) || 50;
    
    if (!slider || !beforeImage) return;

    let isDragging = false;

    // Fonction optimisée avec requestAnimationFrame
    function updateSlider(clientX) {
      requestAnimationFrame(() => {
        const rect = container.getBoundingClientRect();
        let percentage = ((clientX - rect.left) / rect.width) * 100;
        percentage = Math.max(0, Math.min(100, percentage));
        
        slider.style.left = percentage + '%';
        beforeImage.style.width = percentage + '%';
      });
    }

    // Mouse events
    container.addEventListener('mousedown', (e) => {
      isDragging = true;
      updateSlider(e.clientX);
      e.preventDefault();
    });

    // Écouter sur window pour plus de réactivité
    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      updateSlider(e.clientX);
    });

    window.addEventListener('mouseup', () => {
      isDragging = false;
    });

    // Touch events - passifs désactivés pour plus de réactivité
    container.addEventListener('touchstart', (e) => {
      isDragging = true;
      updateSlider(e.touches[0].clientX);
    }, { passive: true });

    window.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      updateSlider(e.touches[0].clientX);
    }, { passive: true });

    window.addEventListener('touchend', () => {
      isDragging = false;
    });

    // Click direct
    container.addEventListener('click', (e) => {
      updateSlider(e.clientX);
    });

    container.dataset.initialized = 'true';
  }

  // Animations
  function initAnimations() {
    const animatedElements = document.querySelectorAll('.cds-ba-animate');
    const sliderAnimatedContainers = document.querySelectorAll('.cds-ba-animate-slider');
    
    if (!('IntersectionObserver' in window)) {
      animatedElements.forEach(el => el.classList.add('cds-ba-visible'));
      sliderAnimatedContainers.forEach(el => el.classList.remove('cds-ba-animate-slider'));
      return;
    }

    const contentObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('cds-ba-visible');
          contentObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(el => contentObserver.observe(el));

    const sliderObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const container = entry.target;
          const slider = container.querySelector('.cds-before-after__slider');
          const beforeImage = container.querySelector('.cds-before-after__before');
          const startPosition = parseInt(container.dataset.sliderStart) || 50;
          
          container.classList.add('cds-ba-slider-ready');
          
          setTimeout(function() {
            container.classList.remove('cds-ba-animate-slider');
            if (slider) slider.style.left = startPosition + '%';
            if (beforeImage) beforeImage.style.width = startPosition + '%';
          }, 100);
          
          sliderObserver.unobserve(container);
        }
      });
    }, {
      threshold: 0.2
    });

    sliderAnimatedContainers.forEach(el => sliderObserver.observe(el));
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllSliders();
      initAnimations();
    });
  } else {
    initAllSliders();
    initAnimations();
  }

  // Shopify Editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      const container = section.querySelector('.cds-before-after__slider-container');
      if (container) {
        container.dataset.initialized = '';
        initSlider(container);
      }
      initAnimations();
    });
  }
})();